<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Next Step Member Assignment</p>
        <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>

<div mat-dialog-content>
    <div class="row m-0 eip-pt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
        <div class="col">
            <kendo-grid [kendoGridBinding]="successList" [sortable]="false" [resizable]="true"
                [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvStatusList">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <kendo-grid-column field="documentNumber" title="Document Number" width="80">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto">
                            {{dataItem.documentNumber}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="revisionNo" title="Revision" width="50">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="">
                            {{dataItem.revisionNo}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Next Step" width="80">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.nextStepDetail.workflow_Status_Description}}"
                            eipTooltipPosition="auto">
                            {{dataItem.nextStepDetail.workflow_Status_Description}}
                        </span>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column title="Role Members AssignTo" width="450">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <span class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngFor="let roles of dataItem.nextStepAssignedToRoles">
                            <EIPMultiSelectAutoComplete [dataSource]="roles.roleMembers" ShowTextValueField='N'
                                setId="dataItem.documentId{{rowIndex}}" [WaterMarkText]="roles.role_Description"
                                TextField="memberName" ValueField="memberId" 
                                [defaultSelectedValues]="roles.roleSelectedMembers"
                                (valueChange)="onChange_Member($event,dataItem,roles.role_Id,rowIndex)" >
                            </EIPMultiSelectAutoComplete>
                            <mat-error *ngIf="selectedDocumentMembers && selectedDocumentMembers?.get(dataItem.documentId)?.get(roles.role_Id).length<=0" style="font-size: smaller;font-weight: bold;"
                            >Value Required</mat-error>
                        </span>
                        <span class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngFor="let roles of dataItem.assignedToMemberDetails">
                            <EIPMultiSelectAutoComplete [dataSource]="roles.Members" ShowTextValueField='N'
                                setId="dataItem.documentId{{rowIndex}}" [WaterMarkText]="roles.Description"
                                TextField="member_Name" ValueField="member_Id" 
                                [defaultSelectedValues]="roles.selectedMembersIds"
                                (valueChange)="onChange_DirectMember($event,dataItem)" >
                            </EIPMultiSelectAutoComplete>
                            <mat-error *ngIf="roles.selectedMembersIds && roles.selectedMembersIds.length<=0" style="font-size: smaller;font-weight: bold;"
                                >Value Required</mat-error>
                        </span>
                    </ng-template>
                </kendo-grid-column>

            </kendo-grid>
        </div>
    </div>
    <div style="display: flex;justify-content: center;">
        <div class="notification">
            <p style="margin-left: 2%;font-style: italic;"><strong>Note </strong>
                <br>
                * Reassignment is applicable only for members whose action is yet pending.
                <br>
                * Click "Re-Assign & Proceed" button only if any member assigned is modified; otherwise, close the tab.
                <br>
            </p>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button type="button" class="btn btn-primary" (click)="changeUser()" [disabled]="isDisable" id="btnEDMSave"><i class="fa fa-delegated-access" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Re-Assign & Proceed</button>
        <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-times-circle" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Close</button>
    </div>
</div>
